/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BillStateEnum } from './billStateEnum';
import { Direction } from './direction';
import { QueuedJobState } from './queuedJobState';
import { QueuedSmsJobModel } from './queuedSmsJobModel';
import { TransactionLog } from './transactionLog';


export interface ProcessedToSendSmsOverSmpp { 
    id: string;
    smsRouteUtilized?: string;
    referenceNumber?: string;
    messageId?: string;
    creatorId?: string;
    smsPriceConfigName?: string;
    processingCost: number;
    routeGroupName?: string;
    queuedSmsJob?: QueuedSmsJobModel;
    transactionLog?: TransactionLog;
    mtFilterMO?: any;
    billStateId: number;
    jobStateId: number;
    direction: Direction;
    jobState: QueuedJobState;
    billState: BillStateEnum;
    dateCreated: Date;
    smsCost: number;
    smsPages: number;
}
